import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation,Navigate } from 'react-router-dom';
import ChatBox from './components/Chatbox';
import UnauthenticatedChat from './components/UnauthenticatedChat';
import MultistepForm from './components/MultiStepForm';
import Login from './components/Login';
import Register from './components/Register';
import ProtectedRoute from './components/protectedRoute';
import { jwtDecode } from 'jwt-decode';
import './App.css';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import Navbar from './components/Navbar/HomeNavbar';
import Bg from './assets/first-bg.png'
import MobileBg from './assets/mobile-bg.png'
import AnswerModeChatBox from './components/AnswerModeChatBox';
import Signup from './components/Signup';
import ThankYou from './components/ThankYou';

Amplify.configure(awsconfig);

function AppWrapper() {
    return (
        <Router>
            <App />
        </Router>
    );
}

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userId, setUserId] = useState(null);
    const [isAuthChecked, setIsAuthChecked] = useState(false); // New state to ensure routes load after auth check
    const navigate = useNavigate();
    const location = useLocation();
    const [showSidebar, setShowSidebar] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);



const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
  
    useEffect(() => {
      // Handler to call on window resize
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };
  
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler immediately to set initial size
      handleResize();
      
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    return windowSize;
  };
  const { width } = useWindowSize();


    useEffect(() => {
        console.log("useEffect triggered");
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');

        if (code) {
            exchangeCodeForTokens(code);
        } else {
            const userEmail = localStorage.getItem('userEmail');
            if (userEmail) {
                setIsAuthenticated(true);
                setUserId(userEmail);
            }
            setIsAuthChecked(true); // Mark auth check complete
        }
    }, []);

    const url = process.env.REACT_APP_FRONTEND_DOMAIN_NAME;
    const client_Id = process.env.REACT_APP_COGNITO_CLIENT_ID;

    const exchangeCodeForTokens = async (code) => {
        const clientId = client_Id;
        const redirectUri = url;
        const cognitoDomain = "https://us-east-1rd5hzgep6.auth.us-east-1.amazoncognito.com";

        const tokenEndpoint = `${cognitoDomain}/oauth2/token`;

        const body = new URLSearchParams({
            grant_type: "authorization_code",
            client_id: clientId,
            redirect_uri: redirectUri,
            code: code,
        });

        try {
            const response = await fetch(tokenEndpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: body.toString(),
            });

            if (!response.ok) {
                throw new Error("Failed to exchange code for tokens");
            }

            const tokens = await response.json();
            const { id_token } = tokens;

            // Decode the token to extract user information
            const decodedToken = jwtDecode(id_token);
            console.log("Decoded Token:", decodedToken);

            const userEmail = decodedToken.email;
            const userName = decodedToken.name;

            // Save user details in local storage
            localStorage.setItem('userEmail', userEmail);
            localStorage.setItem('userName', userName);

            // Set state
            setIsAuthenticated(true);
            setUserId(userEmail);

            // Navigate to /chat
            navigate('/chat');
        } catch (error) {
            console.error("Error exchanging code for tokens:", error);
        } finally {
            setIsAuthChecked(true); // Ensure the auth check is marked complete
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userName');
        localStorage.removeItem('selectedChatId');
        setIsAuthenticated(false);
        setUserId(null);
        navigate('/');
    };

    if (!isAuthChecked) {
        // Show a loader while checking authentication
        return <div>Loading...</div>;
    }
    

    const toggleSidebar = () => {
      setShowSidebar(prev => !prev);
    };
  
    const openAddChat = () => {
        setIsModalOpen(true);
      };
    return (
        <div className="App">
            {location.pathname === '/' && <img
          src={width < 768 ? MobileBg : Bg}
          className="background-image"
          alt="Background"
        />}

            <Navbar showSidebar={showSidebar} isAuthenticated={isAuthenticated} handleLogout={handleLogout} toggleSidebar={toggleSidebar} openAddChat={openAddChat}/> 
   
            <Routes>
                <Route
                    path="/"
                    element={
                        isAuthenticated ? (
                            <Navigate to="/chat" replace />
                        ) : (
                            <MultistepForm isAuthenticated={isAuthenticated} handleLogout={handleLogout} />
                        )
                    }
                />
                <Route path="/answer-chat/:chatId?" element={<AnswerModeChatBox userId={userId} />} />
                <Route path="/unauthenticated-chat" element={<UnauthenticatedChat />} />
                <Route path="/login" element={<Login />} />
                {/* <Route path="/register" element={<Register />} /> */}
                <Route path="/register" element={<Signup />} />

                <Route
                    path="/chat/:chatId?"
                    element={
                        <ProtectedRoute isAuthenticated={isAuthenticated}>
                            <ChatBox userId={userId} showSidebar={showSidebar} setShowSidebar={setShowSidebar} isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen }  isAuthenticated={isAuthenticated} handleLogout={handleLogout}/>
                        </ProtectedRoute>
                    }
                />
                <Route path='/thank-you' element={<ThankYou/>}/>
            </Routes>
        </div>
    );
}


export default AppWrapper;
